export default "__VITE_ASSET__CvGn2aeV__"